export const CATALOGUE = "catalogue";
export const SOURCE = "source";
export const BATCH_POSITION = "batch_images"

export const POSITION = "position";

export const RA = "ra";
export const DEC = "dec";
export const RADIUS = "radius";
export const SEARCHBY = "searchBy";
export const CUTOUT_SIZE="cutout_size";

